export default "__VITE_ASSET__8vENT9qE__"